import React, { createContext } from 'react';

export const FormContext = createContext(null);

export const withFormContext = Component => props => (
  <FormContext.Consumer>
    {formContext => <Component {...props} formContext={formContext} />}
  </FormContext.Consumer>
);